import React, { useEffect, useMemo, useState } from 'react'
import { Image } from 'Components/view-image'
import noopWrapper, { Wrapper } from 'lib/noop-wrapper'
import useExpandAutoScroll from 'Components/hooks/use-expand-auto-scroll'
import ImageViewer from 'Components/ugc/imageViewer'
import classNames from 'classnames'
import { useResponsive } from 'Components/hooks/use-responsive'

export interface IImageItem {
  src?: string
  alt?: string
}

interface IProps {
  imageList?: IImageItem[]
  max?: number
  linkWrapper?: Wrapper
}

const ImageList: React.FC<IProps> = ({
  imageList,
  linkWrapper = noopWrapper,
}) => {
  const [moreCount, setMoreCount] = useState(0)

  const responsive = useResponsive()

  useEffect(() => {
    setMoreCount(imageList ? imageList.length - (responsive['2xl'] ? 6 : 5) : 0)
  }, [imageList, responsive])

  const { expanded, toggleExpand, rootRef } =
    useExpandAutoScroll<HTMLDivElement>()

  const [activeIndex, setActiveIndex] = useState(0)

  return imageList?.length ? (
    <React.Fragment>
      <div ref={rootRef} className="tw-mt-12">
        {expanded ? (
          <ImageViewer
            imgList={imageList.map(({ src }) => src || '') || []}
            activeIndex={activeIndex}
            onClick={toggleExpand}
          />
        ) : (
          <div className={`tw-grid tw-grid-cols-5 2xl:tw-grid-cols-6 tw-gap-8`}>
            {imageList.map((item, index) => {
              return (
                <div
                  key={`${item.src}${index}`}
                  className={classNames('wrapper tw-relative', {
                    'tw-hidden': index >= 5,
                    '2xl:tw-block': index === 5,
                  })}
                >
                  <Image
                    width={160}
                    height={160}
                    src={item.src || ''}
                    alt={item.alt}
                    hoverTransition
                    className="tw-rounded-2 g-load-img-wrap tw-cursor-zoom-in"
                    autoPixelRatio
                    layout={'responsive'}
                    onClick={() => {
                      setActiveIndex(index)
                      toggleExpand()
                    }}
                  />
                </div>
              )
            })}
          </div>
        )}
      </div>
      <style jsx>
        {`
          .wrapper {
            border-radius: 2px;
            line-height: 0;
          }
          .wrapper:nth-child(${responsive['2xl'] ? 6 : 5}):after {
            content: ${moreCount ? `'+${moreCount}'` : 'none'};
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 24px;
            font-family: D-DINExp;
            color: #fff;
            background-color: rgba(0, 0, 0, 0.4);
            pointer-events: none;
          }
        `}
      </style>
    </React.Fragment>
  ) : null
}

export default ImageList
